/**
 * @generated SignedSource<<001490db14bffb71c40a140a5b23959d>>
 * @relayHash 6d01809d4cb28ed0afb420eee7a4ba30
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2b46b4e32b7684bbebfcdf832f2bea67edb4a0a7bfe08a6ae5f4fb5f6dd5c421

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterSettingsWidgetConfigurationInstallAppQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
  widgetId: string;
};
export type HelpCenterSettingsWidgetConfigurationInstallAppQuery$data = {
  readonly csmAi_getWidget: {
    readonly __typename: "CsmAiWidgetConfig";
    readonly " $fragmentSpreads": FragmentRefs<"Install_AtlassianCsmWidgetConfiguration_fragmentRef" | "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly " $fragmentSpreads": FragmentRefs<"brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
    readonly helpCenterPermissionSettings: {
      readonly " $fragmentSpreads": FragmentRefs<"Install_AtlassianCsmWidgetConfiguration_accessControlDataRef">;
    };
  } | null | undefined;
};
export type HelpCenterSettingsWidgetConfigurationInstallAppQuery = {
  response: HelpCenterSettingsWidgetConfigurationInstallAppQuery$data;
  variables: HelpCenterSettingsWidgetConfigurationInstallAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widgetId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "helpCenterAri",
  "variableName": "helpCenterAri"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "widgetId",
    "variableName": "widgetId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v5 = [
  (v1/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "type"
},
v8 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getWidget",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference"
              },
              {
                "kind": "FragmentSpread",
                "name": "Install_AtlassianCsmWidgetConfiguration_fragmentRef"
              }
            ],
            "type": "CsmAiWidgetConfig"
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference"
                  }
                ],
                "type": "HelpCenter"
              }
            ]
          },
          {
            "kind": "RequiredField",
            "field": {
              "args": (v5/*: any*/),
              "kind": "LinkedField",
              "name": "helpCenterPermissionSettings",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "Install_AtlassianCsmWidgetConfiguration_accessControlDataRef"
                    }
                  ],
                  "type": "HelpCenterPermissionSettings"
                }
              ]
            },
            "action": "THROW",
            "path": "helpCenter.helpCenterPermissionSettings"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getWidget",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "allowedDomains"
              },
              {
                "kind": "ScalarField",
                "name": "isAnonymousAccessEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isEnabled"
              },
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "position"
              },
              {
                "concreteType": "CsmAiWidgetBrandingTheme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "colorVibeVariant"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "radius"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "space"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "chatColor"
                  },
                  {
                    "concreteType": "CsmAiWidgetBrandingAttribution",
                    "kind": "LinkedField",
                    "name": "attribution",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "text"
                      },
                      (v8/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "CsmAiWidgetIcon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              }
            ],
            "type": "CsmAiWidgetConfig"
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterPermissionSettings",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "accessControlType"
                  }
                ],
                "type": "HelpCenterPermissionSettings"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2b46b4e32b7684bbebfcdf832f2bea67edb4a0a7bfe08a6ae5f4fb5f6dd5c421",
    "metadata": {},
    "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d8f4bbcfd5b816dc889ffe8babc02e73";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
